import ServiceTemplate from '@/components/ServiceTemplate';

export default function Bookkeeping() {
  const data = {
    title: 'Professional Bookkeeping Services',
    subtitle: 'Expert bookkeeping and financial record management for your business.',
    overviewTitle: 'Why Professional Bookkeeping Matters',
    overviewImage: 'https://images.unsplash.com/photo-1704969723938-0c310608d6c1',
    description: [
      'Accurate bookkeeping is essential for business success, providing the financial insights needed for decision-making, tax compliance, and business growth. Professional bookkeeping ensures your records are accurate, complete, and compliant.',
      'Our bookkeeping service handles all aspects of financial record-keeping, from transaction recording to financial statement preparation, using modern accounting software and best practices.',
      'We provide monthly financial reports, reconciliations, and ongoing support to keep your finances organized and ensure you always know your business\'s financial position.'
    ],
    benefits: [
      { title: 'Accurate Records', description: 'Professional recording of all financial transactions.' },
      { title: 'Tax Preparation', description: 'Organized records ready for tax filing.' },
      { title: 'Financial Insights', description: 'Regular reports showing business performance.' },
      { title: 'Time Savings', description: 'Focus on business while we handle the books.' },
      { title: 'Compliance', description: 'Ensure compliance with accounting standards.' },
      { title: 'Cash Flow Management', description: 'Better understanding of cash position.' }
    ],
    process: [
      { title: 'Initial Setup & Assessment', description: 'Comprehensive evaluation of current situation and establishment of service framework.' },
      { title: 'Implementation & Management', description: 'Execute ongoing services with regular monitoring, reporting, and optimization.' },
      { title: 'Review & Strategic Guidance', description: 'Periodic reviews with strategic recommendations for continuous improvement.' }
    ],
    pricing: [
      {
        name: 'Consultation',
        description: 'Initial assessment',
        price: '$299',
        period: 'Per session',
        features: [
          '90-minute consultation',
          'Situation analysis',
          'Strategy recommendations',
          'Action plan',
          'Written summary',
          'Follow-up email support'
        ]
      },
      {
        name: 'Retainer',
        description: 'Ongoing advisory',
        price: '$1,499',
        period: 'Per month',
        featured: true,
        features: [
          'Monthly strategy sessions',
          'Unlimited email support',
          'Priority phone access',
          'Document review',
          'Compliance monitoring',
          'Quarterly reporting',
          'Dedicated attorney'
        ]
      },
      {
        name: 'Project-Based',
        description: 'Custom engagement',
        price: 'Custom',
        period: 'Based on scope',
        features: [
          'Scope-based pricing',
          'Dedicated team',
          'Project management',
          'Milestone deliverables',
          'All work product included',
          'Comprehensive reporting',
          'Executive support'
        ]
      }
    ],
    faqs: [
      { question: 'What does bookkeeping include?', answer: 'Services include transaction recording, bank reconciliation, accounts payable/receivable, payroll processing, and financial statement preparation.' },
      { question: 'How often should bookkeeping be done?', answer: 'Monthly bookkeeping is standard, though weekly or quarterly services are available based on business needs and transaction volume.' },
      { question: 'What software do you use?', answer: 'We work with QuickBooks, Xero, FreshBooks, and other popular accounting platforms, or can recommend the best solution for your business.' },
      { question: 'Do you handle payroll?', answer: 'Yes, we provide payroll processing services including tax withholding, filing, and compliance with payroll regulations.' },
      { question: 'How do you receive my financial documents?', answer: 'Documents can be provided via secure upload, cloud accounting software integration, or bank feed connections.' },
      { question: 'Can you clean up past records?', answer: 'Yes, we offer catch-up bookkeeping services to organize and correct historical records.' },
      { question: 'What reports will I receive?', answer: 'Standard reports include profit & loss statements, balance sheets, cash flow statements, and accounts aging reports.' },
      { question: 'Is bookkeeping different from accounting?', answer: 'Bookkeeping focuses on recording transactions, while accounting involves analysis, tax planning, and strategic financial guidance. We offer both services.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
